import React from 'react';
import { Box, Typography, Stack, Divider, Button } from '@mui/material';
import { CalendarMonth, AccessTime } from '@mui/icons-material';

const labelSx = { color: '#718096', fontWeight: 700, display: 'block', mb: 0.5 };
const timeOpts = { hour: '2-digit', minute: '2-digit' };

const ConferenceBanner = ({ conference, reservation }) => {
  // Récupération sécurisée des dates (depuis la conf ou depuis la réservation principale)
  const startDateStr = conference?.start_date_conf || reservation?.start_time_reservation;
  const endDateStr = conference?.end_date_conf || reservation?.end_time_reservation;

  const startDate = startDateStr ? new Date(startDateStr) : null;
  const endDate = endDateStr ? new Date(endDateStr) : null;

  const isValidDate = (date) => date && !isNaN(date.getTime());

  // Détection d'un vrai lien Zoom ou ID de réunion
  const zoomLink = conference?.lien_conference || conference?.join_url || conference?.url;
  const zoomId = conference?.id_meeting_conf;
  const hasZoom = Boolean(zoomId || zoomLink);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 3,
        bgcolor: 'white',
        borderRadius: '12px',
        border: '1px solid #E2E8F0',
        boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
        flexWrap: { xs: 'wrap', md: 'nowrap' },
        gap: 2,
      }}
    >
      {/* 📅 DATE ET CRÉNEAU HORAIRE (TOUJOURS AFFICHÉS) */}
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={4}
        divider={<Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', sm: 'block' } }} />}
      >
        <Box>
          <Typography variant="caption" sx={labelSx}>
            DATE DE LA SÉANCE
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <CalendarMonth sx={{ color: '#4A5568', fontSize: 20 }} />
            <Typography sx={{ fontWeight: 700, color: '#2D3748' }}>
              {isValidDate(startDate)
                ? startDate.toLocaleDateString('fr-FR', {
                    weekday: 'long',
                    day: 'numeric',
                    month: 'long',
                  })
                : 'Date non définie'}
            </Typography>
          </Stack>
        </Box>

        <Box>
          <Typography variant="caption" sx={labelSx}>
            CRÉNEAU HORAIRE
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <AccessTime sx={{ color: '#4A5568', fontSize: 20 }} />
            <Typography sx={{ fontWeight: 800, color: '#2D3748' }}>
              {isValidDate(startDate) && isValidDate(endDate) ? (
                <>
                  {startDate.toLocaleTimeString([], timeOpts)}
                  <span style={{ margin: '0 8px', color: '#CBD5E0' }}>—</span>
                  {endDate.toLocaleTimeString([], timeOpts)}
                </>
              ) : (
                'Horaire non défini'
              )}
            </Typography>
          </Stack>
        </Box>
      </Stack>

      {/* 🔴 BLOC ZOOM : Masqué s'il n'y a pas de lien Zoom */}
      {hasZoom && (
        <Box
          sx={{
            bgcolor: '#EDF2F7',
            p: 1.5,
            px: 2.5,
            borderRadius: '8px',
            border: '1px dashed #CBD5E0',
            minWidth: '160px',
            textAlign: 'center',
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: '#4A5568',
              fontWeight: 800,
              display: 'block',
            }}
          >
            RÉUNION ZOOM
          </Typography>

          {zoomLink ? (
            <Button
              href={zoomLink}
              target="_blank"
              rel="noopener noreferrer"
              size="small"
              sx={{ fontWeight: 700, color: '#4318FF', textTransform: 'none', p: 0, mt: 0.5 }}
            >
              Rejoindre la réunion
            </Button>
          ) : (
            <Typography
              sx={{
                fontFamily: 'monospace',
                fontWeight: 700,
                fontSize: '1rem',
                color: '#2D3748',
              }}
            >
              {zoomId}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ConferenceBanner;